import { Broadcast } from "entities/broadcasts/types";
import React, { FC, PropsWithChildren } from "react";
import { useDrawerState } from "shared/hooks/useDrawerState";
import { createContext } from "shared/utils/context";
import { useBroadcastsData } from "../../../hooks/useBroadcastsData";
import { BroadcastsPageType } from "./types";

const [Provider, useBroadcastsPage] = createContext<BroadcastsPageType>({
  name: "BroadcastsPageContext",
  hookName: "useBroadcastsPage",
  providerName: "BroadcastsPageProvider",
});

const BroadcastsPageProvider: FC<PropsWithChildren> = ({ children }) => {
  const {
    searchData,
    isLoading,
    tableData,
    addBroadcastOptimistically,
    updateBroadcastOptimistically,
  } = useBroadcastsData();
  const broadcastDetailsDrawer = useDrawerState<Broadcast>();

  // eslint-disable-next-line react/jsx-no-constructed-context-values
  const value = {
    loading: isLoading,
    searchData,
    tableData: {
      ...tableData,
      addBroadcastOptimistically,
      updateBroadcastOptimistically,
    },
    broadcastDetailsDrawer,
  };

  return <Provider value={value}>{children}</Provider>;
};

export { BroadcastsPageProvider, useBroadcastsPage };
